// Swap imagery here — all photos live in /public/images and are generic
// Honolulu / ocean-and-skyline stock placeholders (no developer renderings).
export const IMAGES = {
  hero: "/images/hero-ocean.jpg",
  tower: "/images/tower-sunset.jpg",
  interiorLiving: "/images/interior-living.jpg",
  interiorOcean: "/images/interior-ocean.jpg",
  marlene: "/images/marlene-portrait.jpg",
  neighborhood: "/images/neighborhood-hawaii.jpg",
  wellnessWater: "/images/wellness-water.jpg",
  wellnessSpa: "/images/wellness-spa-water.jpg",
};

export const CONTACT = {
  phoneDisplay: "808-989-6741",
  phoneHref: "tel:+18089896741",
  smsHref: "sms:+18089896741",
  email: "marlenealesna.realestate@gmail.com",
  emailHref: "mailto:marlenealesna.realestate@gmail.com",
  calendly: "https://calendly.com/marlenealesna/728-ala-moana-talk-story-call",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PUBLIC_SITE_URL = "https://728alamoana.com";
